const DEFAULT_LOCALE = 'en';

const callApi = (url,
  config,
  onRequestSuccess,
  onRequestFailure) => {
  if (config.method.toUpperCase() === 'GET') {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    
    if (config.body) {
      const bodyData = config.body instanceof FormData ? Object.fromEntries(config.body.entries()) : JSON.parse(config.body);
      for (const [key, value] of Object.entries(bodyData)) {
        params.append(key, value);
      }
    }
    
    urlObj.search = params.toString();
    url = urlObj.toString();
    delete config.body; // Remove the body for GET request
  } else if (config.body) {
    if (config.body instanceof FormData) {
      config.body.append('locale', config.body.get('locale') || localStorage.LANG || DEFAULT_LOCALE);
    } else {
      const bodyData = JSON.parse(config.body);
      bodyData.locale = bodyData.locale || localStorage.LANG || DEFAULT_LOCALE;
      config.body = JSON.stringify(bodyData);
    }
  } else {
    config.body = JSON.stringify({
      locale: localStorage.LANG || DEFAULT_LOCALE,
    });
  }

  fetch(url, config)
    .then((response) => {
      if (response.status === 401 && !/\/oauth\/token$/.test(url)) {
        localStorage.removeItem('ACCESS_TOKEN');
        localStorage.removeItem('REFRESH_TOKEN');
        localStorage.removeItem('MEMBER');
        localStorage.removeItem('MENUS');
        document.cookie = `ACCESS_TOKEN=`
        document.cookie = `REFRESH_TOKEN=`
        window.location.href = '/login';
      }
      return response.json();
    })
    .then((data) => onRequestSuccess(data))
    .catch((err) => onRequestFailure(err));
};

export { callApi, DEFAULT_LOCALE };
